import axios from "axios";

class ClientContractService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
  * @author Lucia Alvarado
  * @description Get companys
  * @date 15-07-2022
  * @param {String} token
  * @param {Number} clientId
  * @returns {Object}
  * @memberof ClientCompanyService
  */
  async getClientContract(token, dateStart, dateLimit) {
    let response = await axios.get(
      `${this.apiUrl}/dashboard?dateStart=${dateStart}}&dateLimit=${dateLimit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description Get contract by id
  * @date 06-01-2023
  * @param {String} token
  * @param {Number} clientContractId
  * @returns {Object}
  * @memberof ClientContractService
  */
  async getContractById(clientContractId, token) {
    let response = await axios.get(
      `${this.apiUrl}/contract-details?clientContractId=${clientContractId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description Get questions for contract by id
  * @date 1-01-2023
  * @param {String} token
  * @param {Number} clientContractId
  * @returns {Object}
  * @memberof ClientCompanyService
  */
  async getQuesitonsForContractById(clientContractId, token) {
    let response = await axios.get(
      `${this.apiUrl}/question-sheet-contract-by-id?clientContractId=${clientContractId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description Get lawyers by clientId
  * @date 16-01-2023
  * @param {String} token
  * @param {Number} clientId
  * @returns {Object}
  * @memberof ClientContractService
  */
  async getLawyersByClientId(clientId, token) {
    let response = await axios.get(
      `${this.apiUrl}/users-lawyer?clientId=${clientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }


  /**
  * @author Edgar Escobedo
  * @description Save lawyer´s id for contract 
  * @date 16-01-2023
  * @param {String} token
  * @param {Number} clientContractId
  * @param {Number} userLawyerId
  * @returns {Object}
  * @memberof ClientContractService
  */
  async assignLawyerForContract(clientContractId, userLawyerId, token) {
    let response = await axios.put(
      `${this.apiUrl}/assing-lawyer `,
      { clientContractId, userLawyerId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description Answer questions contract
  * @date 16-01-2023
  * @param {String} token
  * @param {Number} clientContractId  
  * @param {Array} answerList 
  * @returns {Object}
  * @memberof ClientContractService
  */
  async saveAnswersQuestionsContract(clientContractId, answerList, token) {
    let response = await axios.post(
      `${this.apiUrl}/answers`,
      { clientContractId, answerList, },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description Generate contract
  * @date 17-01-2023
  * @param {String} token
  * @param {Number} clientContracId    
  * @returns {Object}
  * @memberof ClientContractService
  */
  async generateContract(clientContracId, token) {
    let response = await axios.post(
      `${this.apiUrl}/generate-contract`,
      {
        clientContracId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return response.data;
  }

  /**
  * @author Brayan Salas
  * @description Get SolicitudUrl By ClientContractId
  * @date 23-01-2023
  * @param {String} token
  * @param {Number} clientContractId
  * @returns {Object}
  * @memberof ClientContractService
  */
  async getInboxByClientContractId(clientContractId, type, token) {
    let response = await axios.get(
      `${this.apiUrl}/inbox-details?clientContractId=${clientContractId}&inboxTypeKey=${type}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description load contract
  * @date 20-01-2023
  * @param {String} token
  * @param {file} clientContracFile  
  * @returns {Object}
  * @memberof ClientContractService
  */
  async loadContract(clientContractFile, token) {
    let response = await axios.put(
      `${this.apiUrl}/load-contract`, clientContractFile,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description delete contract
  * @date 20-01-2023
  * @param {String} token
  * @param {number} clientContractId  
  * @returns {Object}
  * @memberof ClientContractService
  */
  async deleteContract(clientContractId, token) {
    let response = await axios.delete(
      `${this.apiUrl}/delete-contract?clientContractId=${clientContractId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return response
  }

  /**
  * @author Brayan Salas
  * @description Get the document status (is open) by clientContractId
  * @date 23-01-2023
  * @param {String} token
  * @param {Number} clientContractId
  * @returns {Object}
  * @memberof ClientContractService
  */
  async isOpenClientContract(clientContractId, token) {
    let response = await axios.get(
      `${this.apiUrl}/file-contract-status?clientContractId=${clientContractId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.data;
  }

  /**
  * @author Brayan Salas
  * @description load contract
  * @date 20-01-2023
  * @param {String} token
  * @param {file} clientContracFile  
  * @returns {Object}
  * @memberof ClientContractService
  */
  async setIsOpenClientContract(clientContractId, clientContractOpen, token) {
    let response = await axios.put(
      `${this.apiUrl}/file-contract-status`, { clientContractId, clientContractOpen },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data.data;
  }
}

export { ClientContractService as default };
